import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import { getTasksQuery } from "@/modules/tasks/api/queries/getTasksQuery";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

import { parseTasksList } from "../utils/parseTasksList";

const translationNamespace = "apiMessages/useGetTasksQuery";

export function useGetTasksQuery() {
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  const { userCompanyId } = useAuthContext();
  const { currentGroup } = useUserDataContext();
  return useQuery(
    userCompanyId && currentGroup
      ? {
          queryKey: [queryKeys.tasks.getTasksList, currentGroup, userCompanyId],
          queryFn: () =>
            getTasksQuery(jsonApi, {
              userGroupId: currentGroup.id,
            }),
          retry: false,
          refetchOnWindowFocus: false,
          select: (response) => {
            if (response) {
              return parseTasksList(response);
            }
          },
          onError: (error) => {
            apiErrorValidate(error, {
              401: {
                UNAUTHORIZED: t(
                  "You are not allowed to view tasks. Please sign in again"
                ),
              },
              403: {
                ACCESS_FORBIDDEN: t("You don't have an access to view tasks"),
              },
            });
          },
        }
      : { enabled: false }
  );
}
